import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AdminHome from '../views/AdminHome.vue'
import Admin from '../views/Admin.vue'
import AdminPatrocinadores from '../views/Admin/Patrocinadores/Patrocinadores.vue'
import AdminPublicaciones from '../views/Admin/Publicaciones.vue'
import AdminPublicacionesMultiples from '../views/Admin/PublicacionesMultiples.vue'
import PublicacionMultiple from '../views/Publicacion/PublicacionMultiple.vue'
import AdminAgregarPublicacion from '../views/Admin/AddPublicacion.vue'
import AdminAgregarPublicacionMultiple from '../views/Admin/AddPublicacionMultiple.vue'
import AdminIndices from '../views/Admin/Indices.vue'
import AdminDetalleIndice from '../views/Admin/DetalleIndice.vue'
import AdminAddDataIndice from '../views/Admin/AddDataIndice.vue'
import AdminUsuarios from '../views/Admin/Usuarios/Usuarios.vue'
import AdminVariables from '../views/Admin/Variables.vue'
import AdminDetalleVariable from '../views/Admin/DetalleVariable.vue'
import AdminAddDataVariable from '../views/Admin/AddDataVariable.vue'
import AdminClima from '../views/Admin/Clima.vue'
import AdminAddDataClima from '../views/Admin/AddDataClima.vue'
import HomePublicacion from '../views/Publicacion/Publicacion.vue'
import Comentarios from '../views/Admin/Comentarios.vue'
import Contactos from '../views/Admin/Contactos.vue'

import { authGuard } from "../auth/authGuard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Inicio - Espacio Honduras'
    }
  },
  {
    path: '/admin',
    component: AdminHome,
    beforeEnter: authGuard,
    children: [
      {
        path: "/",
        component: Admin,
        meta: {
          title: 'Admin - Espacio Honduras'
        },
      },
      {
        path: 'patrocinadores',
        name: 'Admin Socios',
        component: AdminPatrocinadores,
        meta: {
          title: 'Socios Admin - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones',
        name: 'Admin Publicaciones',
        component: AdminPublicaciones,
        meta: {
          title: 'Publicaciones Admin - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones/agregar',
        name: 'Agregar Publicacion',
        component: AdminAgregarPublicacion,
        meta: {
          title: 'Agregar Publicación Admin - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones/:id/comments',
        name: 'Comentarios de publicacion',
        component: Comentarios,
        meta: {
          title: 'Comentarios de publicacion - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones-multiples',
        name: 'Admin Publicaciones Multiples',
        component: AdminPublicacionesMultiples,
        meta: {
          title: 'Publicaciones Multiples Admin - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones-multiples/agregar',
        name: 'Agregar Publicacion Multiple',
        component: AdminAgregarPublicacionMultiple,
        meta: {
          title: 'Agregar Publicación Admin - Espacio Honduras'
        },
      },
      {
        path: 'publicaciones-multiples/:id/comments',
        name: 'Comentarios de publicacion',
        component: Comentarios,
        meta: {
          title: 'Comentarios de publicacion - Espacio Honduras'
        },
      },
      {
        path: 'indices',
        name: 'Admin Indices',
        component: AdminIndices,
        meta: {
          title: 'Indices Admin - Espacio Honduras'
        },
      },
      {
        path: 'indices/:idIndice',
        name: 'Detalle Indice',
        component: AdminDetalleIndice,
        meta: {
          title: 'Detalle Indice Admin - Espacio Honduras'
        },
      },
      {
        path: 'indices/:idIndice/upload-data',
        name: 'Add Data Indice',
        component: AdminAddDataIndice,
        meta: {
          title: 'Add Data Indice Admin - Espacio Honduras'
        },
      },
      {
        path: 'usuarios',
        name: 'Admin Usuarios',
        component: AdminUsuarios,
        meta: {
          title: 'Usuarios Admin - Espacio Honduras'
        },
      },
      {
        path: 'variables',
        name: 'Admin Variables',
        component: AdminVariables,
        meta: {
          title: 'Variables Admin - Espacio Honduras'
        },
      },
      {
        path: 'variables/:idVariable',
        name: 'Detalle Variable',
        component: AdminDetalleVariable,
        meta: {
          title: 'Detalle Variable Admin - Espacio Honduras'
        },
      },
      {
        path: 'variables/:idVariable/upload-data',
        name: 'Add Data Variable',
        component: AdminAddDataVariable,
        meta: {
          title: 'Add Data Variable Admin - Espacio Honduras'
        },
      },
      {
        path: 'clima',
        name: 'Admin Clima',
        component: AdminClima,
        meta: {
          title: 'Clima Admin - Espacio Honduras'
        },
      },
      {
        path: 'clima/largo-plazo/upload-data',
        name: 'Add Data Clima',
        component: AdminAddDataClima,
        meta: {
          title: 'Add Data Clima Admin - Espacio Honduras'
        },
      },
      {
        path: 'contactos',
        name: 'Contacts',
        component: Contactos,
        meta: {
          title: 'Contactos'
        },
        Contactos
      },
    ]
  },
  {
    path: '/publicaciones/:idPublication',
    name: 'Publication',
    component: HomePublicacion,
    meta: {
      title: 'Publication - Espacio Honduras'
    },
  },
  {
    path: '/publicaciones-multiples/:idPublication',
    name: 'Publicacion multiple',
    component: PublicacionMultiple,
    meta: {
      title: 'Publication - Espacio Honduras'
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const Title = to.meta.title;
  if (Title) document.title = Title;
  next();
});

export default router
